import { render, staticRenderFns } from "./DidYouKnow.vue?vue&type=template&id=9be39264&scoped=true&"
import script from "./DidYouKnow.vue?vue&type=script&lang=js&"
export * from "./DidYouKnow.vue?vue&type=script&lang=js&"
import style0 from "./DidYouKnow.vue?vue&type=style&index=0&id=9be39264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be39264",
  null
  
)

export default component.exports